import React, { useRef, PropsWithChildren } from "react";
import {
  CardCarouselHeader,
  CardCarouselPaginationButton,
  CardCarouselWrapper,
  CardCarouselTitle,
  CardCarouselPagination,
  CardCarouselContainer,
  CardCarouselButton,
  CardCarouselCardWrapper,
  CardCarouselSubheading
} from "./card-carousel.styles";
import { Chevron } from "components/icons/chevron";
import { useCardCarousel } from "hooks/use-card-carousel/use-card-carousel";
import { ICardCarouselProps } from "./card-carousel.types";
import { Button } from "components/atoms/button/button";

const CardCarousel: React.FC<PropsWithChildren<ICardCarouselProps>> = ({
  title,
  titleMeta,
  subHeading,
  children,
  buttonText,
  buttonOnClick,
  onScrollToPrevPage,
  onScrollToNextPage,
  isWidthFixed = false,
  autoScroll = false
}) => {
  const CardCarouselRef = useRef<HTMLDivElement>(null);
  const {
    hasLeftItems,
    hasRightItems,
    hidePagination,
    handlePrev,
    handleNext
  } = useCardCarousel({
    carouselRef: CardCarouselRef,
    onScrollToPrevPage,
    onScrollToNextPage,
    autoScroll
  });

  return (
    <CardCarouselWrapper>
      <CardCarouselHeader>
        <CardCarouselTitle titleMeta={titleMeta}>{title}</CardCarouselTitle>
        {subHeading && (
          <CardCarouselSubheading>{subHeading}</CardCarouselSubheading>
        )}
        {!hidePagination && (
          <CardCarouselPagination>
            <CardCarouselPaginationButton
              onClick={handlePrev}
              isDisabled={hasLeftItems}
            >
              <Chevron />
            </CardCarouselPaginationButton>
            <CardCarouselPaginationButton
              onClick={handleNext}
              isDisabled={hasRightItems}
            >
              <Chevron direction="right" />
            </CardCarouselPaginationButton>
          </CardCarouselPagination>
        )}
      </CardCarouselHeader>
      <CardCarouselContainer isWidthFixed={isWidthFixed} ref={CardCarouselRef}>
        {React.Children.map(children, (child) => (
          <CardCarouselCardWrapper>{child}</CardCarouselCardWrapper>
        ))}
      </CardCarouselContainer>
      {buttonText && (
        <CardCarouselButton>
          <Button variant="secondary" onClick={buttonOnClick}>
            {buttonText}
          </Button>
        </CardCarouselButton>
      )}
    </CardCarouselWrapper>
  );
};

export { CardCarousel };
